var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCloudAppEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3842_73791)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3842_73791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.518 9.02939H13.9757L15.2797 7.8411L15.3439 7.33691C12.9175 5.38545 9.2136 5.59572 7.07209 7.80672C6.47667 8.42092 6.04472 9.15143 5.80957 9.9421C5.95481 9.88767 6.11577 9.87907 6.2673 9.91689L8.87471 9.52499C8.87471 9.52499 9.00737 9.32503 9.07591 9.33764C10.2359 8.17685 12.1882 8.04163 13.5274 9.02939H13.518Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1372 9.942C16.8373 8.93648 16.2224 8.03237 15.3667 7.34082L13.537 9.00809C14.3098 9.58333 14.7499 10.4502 14.731 11.3595V11.6557C15.6308 11.6557 16.3595 12.3203 16.3595 13.1396C16.3595 13.9595 15.6301 14.6235 14.731 14.6235H11.4735L11.1484 14.9238V16.7039L11.4735 17.0001H14.731C16.5984 17.0133 18.2552 15.9104 18.8097 14.2855C19.363 12.6601 18.684 10.8954 17.1372 9.942Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21155 16.9836H11.4691V14.6076H8.21155C7.97954 14.6076 7.75005 14.5624 7.53879 14.4741L7.08106 14.603L5.76824 15.7913L5.65381 16.2084C6.39007 16.7149 7.28855 16.9871 8.21155 16.9836Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21153 9.27492C6.402 9.28466 4.79932 10.3406 4.22213 11.903C3.64495 13.4655 4.22025 15.19 5.65442 16.195L7.5438 14.4733C6.72392 14.1358 6.35987 13.2569 6.7302 12.5098C7.10054 11.7627 8.06503 11.4309 8.88492 11.7684C9.24582 11.9174 9.53504 12.1809 9.69851 12.5098L11.5879 10.7881C10.7837 9.83068 9.53441 9.27091 8.21153 9.27492Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3842_73791",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3842_73791"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3842_73791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 11,
    fill: "white",
    transform: "translate(4 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloudAppEdge);
export default __webpack_public_path__ + "static/media/GoogleCloud-App-Edge.c6f4e9adce716757f91921dc75bc9544.svg";
export { ForwardRef as ReactComponent };